import React from 'react';

const CartIcon = () => {
    return (
        <svg id="shopping-bag-52145456" xmlns="http://www.w3.org/2000/svg" width="16.508" height="18.5" viewBox="0 0 16.508 18.5">
            <path id="Path_7655" data-name="Path 76" d="M24.21,35.5H34.3a3.214,3.214,0,0,0,3.21-3.21v-9.6a.571.571,0,0,0-.569-.569H33.523v-.854a4.269,4.269,0,0,0-8.538,0v.854H21.569a.571.571,0,0,0-.569.569v9.6A3.214,3.214,0,0,0,24.21,35.5Zm1.913-14.231a3.131,3.131,0,0,1,6.262,0v.854H26.123Zm-3.985,1.992h2.846v1.423a.569.569,0,0,0,1.138,0V23.262h6.262v1.423a.569.569,0,0,0,1.138,0V23.262h2.846V32.29A2.076,2.076,0,0,1,34.3,34.362H24.21a2.076,2.076,0,0,1-2.072-2.072Z" transform="translate(-21 -17)" fill="#1c1d1b" />
        </svg>
    );
};

export default CartIcon;